<template>
    <div class="page-wrapper">
        <ExternalPartnerTags v-if="$globalConstants.host.goto_tags" />

        <div class="hero-section">
            <HeroBannerController
                :heroType="categoryPageState.heroType"
                :category="heroBannerCategory"
            />
            <FlexibleSpaceA
                v-if="showFlexibleSpaceA && loadQuestionnaireFirst()"
                :style="{
                    ...flexibleSpaceStyle,
                    paddingBottom: '0',
                    ...heroBannerBetaSpaceAStyle,
                }"
                :billboard-partner="
                    categoryState['sidebar_billboard_partner'] || []
                "
                :podium-partners="podiumPartners"
                :is-hero-banner-beta="isHeroBannerBeta"
            />
            <portal-target slim name="on-page-quiz"></portal-target>
        </div>

        <AliyoopChatWidget
            v-if="
                $globalConstants.host['enable_aliyoop_chat_widget'] &&
                categoryState.isLoaded
            "
            :partner-list="this.rankingTablePartners"
            :widget-id="$globalConstants.host['aliyoop_chat_widget_id']"
            :is-stage="
                Boolean(
                    $globalConstants.host[
                        'enable_aliyoop_chat_stage_environment'
                    ]
                )
            "
        >
        </AliyoopChatWidget>

        <template v-if="Boolean(check24WidgetEnabled)">
            <iframe id="check-24-iframe" :src="check24WidgetUrl"></iframe>
        </template>
        <template v-else-if="Boolean(showGamePage)">
            <div
                class="podium-wrapper"
                v-if="$globalConstants.host['adsense_podium']"
            >
                <PartnerPodiumContainer :partners="displayedPartners" />
            </div>
            <AdsenseGameList :category="this.getCategorySlug()" />
        </template>
        <template v-else>
            <main
                class="main-section"
                :style="mainStyle"
                v-if="loadQuestionnaireFirst()"
            >
                <BackgroundImage
                    v-if="showMainSectionBackground"
                    class="ranking-background-image"
                    :imgSource="$globalConstants.host.main_section_background"
                    :intrinsicWidth="!isDesktop() ? '750px' : '1460px'"
                    :intrinsicHeight="!isDesktop() ? '807px' : '1541px'"
                    alt="ranking background image"
                />

                <div
                    class="main-column"
                    :class="
                        isHeroBannerBeta &&
                        !showFlexibleSpaceA &&
                        'hero-banner-overlay'
                    "
                >
                    <template v-if="!isHeroBannerBeta">
                        <UserLocation
                            class="title"
                            v-if="showUserLocation"
                            :user-city="$globalConstants.user['userCity']"
                        />
                        <p
                            v-else-if="
                                showOurSitesText &&
                                !Boolean(check24WidgetEnabled)
                            "
                            class="title --mobile_hidden"
                        >
                            {{ $t('Our Top Sites') }}
                        </p>
                        <Disclosure
                            v-if="
                                showDisclosure && !Boolean(check24WidgetEnabled)
                            "
                        />
                        <CompadoBrandLogo v-if="showBrandLogo" />
                        <!--                        <RatingDisclosure
                                                    v-if="!Boolean(check24WidgetEnabled)"
                                                    :isDbl="$globalConstants.host['domain_id'] === 2"
                                                />-->
                    </template>
                    <template v-else>
                        <DoubleRankingTitle
                            v-if="
                                $globalConstants.host['use_double_ranking'] &&
                                categoryState.category[
                                    'double_ranking_header'
                                ] &&
                                isDesktop()
                            "
                            :content="
                                categoryState.category[
                                    'double_ranking_header'
                                ] ?? $t('Best Games of')
                            "
                            :class="doubleRankingClass"
                            :year="
                                !categoryState.category['double_ranking_header']
                            "
                        >
                        </DoubleRankingTitle>
                        <section class="hero-tool-bar">
                            <div>
                                <UserLocation
                                    class="title"
                                    v-if="showUserLocation"
                                    :user-city="
                                        $globalConstants.user['userCity']
                                    "
                                />

                                <template
                                    v-else-if="
                                        $globalConstants.host.last_updated_month
                                    "
                                >
                                    <span>
                                        {{ $t('Last Updated') }}:
                                        <b>{{ lastUpdateDate }}</b>
                                    </span>
                                </template>
                            </div>
                            <!--                            <div>
                                                            <RatingDisclosure
                                                                :isDbl="
                                                                    $globalConstants.host['domain_id'] === 2
                                                                "
                                                            ></RatingDisclosure>
                                                        </div>-->
                        </section>
                    </template>

                    <PartnerRowController
                        :class="
                            isHeroBannerBeta && 'hero-banner-overlay-partner'
                        "
                        :partners="rankingTablePartners"
                        :partnerRowType="partnerRowType"
                        :showPartners="filteredPartners"
                        :double-ranking-title="
                            categoryPageState &&
                            categoryState.category['double_ranking_header']
                        "
                        :ranking-title="
                            categoryPageState &&
                            categoryState.category['ranking_header']
                        "
                        :double-ranking-class="doubleRankingClass"
                        :category-name="
                            categoryPageState && categoryState.category.name
                        "
                        :flagPosition="
                            categoryPageState && categoryPageState.flagPosition
                        "
                    />
                    <RsocArticles
                        v-if="showArticles"
                        :articles="articleState.articles"
                    />
                    <Portal to="sidebar-billboard" v-if="isMobileDevice()">
                        <SidebarBillboard
                            v-if="showSidebarBillboard"
                            :partner="
                                categoryState['sidebar_billboard_partner']
                            "
                        />
                    </Portal>

                    <template v-if="$globalConstants.host.tip_line">
                        <Portal to="partner-row-tips-stripe">
                            <TipStripe
                                v-bind="
                                    $globalConstants.components['TipStripe']
                                "
                                :text="$globalConstants.host.tip_line_text"
                            />
                        </Portal>
                    </template>

                    <AdBanner
                        v-if="shouldDisplayAdbanner"
                        v-bind="adBannerProps"
                    />

                    <FeaturedPartnerRow
                        v-if="showFeaturedPartner"
                        :partner="displayedPartners[0]"
                        :partner-row-zeta="partnerRowType === 'PartnerRowZeta'"
                        v-bind="
                            $globalConstants.components['FeaturedPartnerRow']
                        "
                    >
                    </FeaturedPartnerRow>
                </div>
                <div
                    v-if="!showSummarySidebar && showSideColumn"
                    class="side-column"
                    :class="isSidebarSticky && '__sticky'"
                    :style="heroBannerBetaSpaceBStyle"
                >
                    <FlexibleSpaceB />
                </div>
            </main>
            <AdsenseGameList
                v-if="showGameList"
                :category="this.getCategorySlug()"
                :show-filters="false"
                :number-of-games-to-display="20"
            />
        </template>
        <div
            v-if="
                showBottomSection &&
                !showSummarySidebar &&
                categoryState.isLoaded
            "
            class="bottom-section"
        >
            <FlexibleSpaceC :style="flexibleSpaceStyle" />
        </div>

        <!--   Summary section with sidebar   -->
        <div
            v-if="
                showBottomSection &&
                showSummarySidebar &&
                categoryState.isLoaded
            "
            class="articles-summary"
            :style="flexibleSpaceStyle"
        >
            <section>
                <FlexibleSpaceC />
            </section>
            <section>
                <div
                    v-if="showSidebar && showSummarySidebar"
                    class="side-column"
                    :class="isSidebarSticky && '__sticky'"
                >
                    <FlexibleSpaceB />
                </div>
            </section>
        </div>
        <!--   Summary section with sidebar   -->
    </div>
</template>

<script>
import { articleStore, categoryStore, quizStore } from '@/store';
import {
    articlesMixin,
    categoryMixin,
    mediaQueriesMixin,
    routeMixin,
    flexibleSpaceMixin,
    adBannerLogic,
    DateMixin,
    check24WidgetMixin,
} from '@/mixins';
import { FLEXIBLE_COMPONENTS } from '@/constants';

import { PaginationObserver } from '@/services/top5-v2-1/pagination-observer';
// import RatingDisclosure from '@/design-system/rating_disclosure/RatingDisclosure';
import PartnerRowController from '@/components/slots/PartnerRowController';
import HeroBannerController from '@organisms/HeroBanners/HeroBannerController';
import FlexibleSpaceA from './components/FlexibleSpaceA/FlexibleSpaceA';
import FlexibleSpaceB from './components/FlexibleSpaceB/FlexibleSpaceB';
import FlexibleSpaceC from './components/FlexibleSpaceC/FlexibleSpaceC';
import { CategoryPageProps } from './CategoryPage.props';
import { HERO_COMPONENTS } from '@organisms/HeroBanners/HeroBanner.constants';
import BackgroundImage from '@atoms/Image/BaseImage';
import TipStripe from '@molecules/TipStripe/TipStripe.vue';

const {
    TESTIMONIALS,
    ARTICLE_CARDS,
    PARTNER_PODIUM,
    CATEGORY_TAGS,
    SUMMARY,
    HERO_SEARCH_BAR,
    HERO_BILLBOARD,
    PARTNER_CARD_CAROUSEL,
    SIDEBAR_BILLBOARD,
    BLACK_FRIDAY_BADGE,
    PODIUM_PRO,
} = FLEXIBLE_COMPONENTS;

export default {
    name: 'CategoryPage',
    components: {
        TipStripe,
        // RatingDisclosure,
        PartnerRowController,
        HeroBannerController,
        FlexibleSpaceA,
        FlexibleSpaceB,
        FlexibleSpaceC,
        BackgroundImage,
        PartnerPodiumContainer: () =>
            import(
                /* webpackChunkName: "PartnerPodiumContainer" */ '@molecules/PartnerPodium/PartnerPodiumContainer.vue'
            ),
        RsocArticles: () =>
            import(
                /* webpackChunkName: "RsocArticles" */ '@organisms/RsocArticles/RsocArticles.vue'
            ),
        AdsenseGameList: () =>
            import(
                /* webpackChunkName: "AdsenseGameList" */ '@/components/AdsenseGameList.vue'
            ),
        CompadoBrandLogo: () =>
            import(
                /* webpackChunkName: "CompadoBrandLogo" */ '@molecules/CompadoBrandLogo/CompadoBrandLogo'
            ),
        FeaturedPartnerRow: () =>
            import(
                /* webpackChunkName: "FeaturedPartnerRow" */ '@organisms/FeaturedPartnerRow/FeaturedPartnerRow'
            ),
        DoubleRankingTitle: () =>
            import(
                /* webpackChunkName: "FeaturedPartnerRow" */ '@atoms/Text/DoubleRankingTitle.vue'
            ),
        Disclosure: () =>
            import(
                /* webpackChunkName: "Disclosure" */ '@molecules/Disclosure/Disclosure'
            ),
        AdBanner: () =>
            import(
                /* webpackChunkName: "AdBanner" */ '@molecules/AdBanner/AdBanner'
            ),
        SidebarBillboard: () =>
            import(
                /* webpackChunkName: "SidebarBillboard" */ '@molecules/SidebarBillboard/SidebarBillboard'
            ),
        UserLocation: () =>
            import(
                /* webpackChunkName: "UserLocation" */ '@/design-system/user_location/UserLocation'
            ),
        ExternalPartnerTags: () =>
            import(
                /* webpackChunkName: "ExternalPartnerTags" */ '@molecules/ExternalPartnerTags/ExternalPartnerTags.vue'
            ),
        AliyoopChatWidget: () =>
            import(
                /* webpackChunkName: "AliyoopChatWidget" */ '@molecules/AliyoopChatWidget/AliyoopChatWidget.vue'
            ),
    },
    mixins: [
        articlesMixin,
        categoryMixin,
        mediaQueriesMixin,
        routeMixin,
        adBannerLogic,
        flexibleSpaceMixin,
        quizStore,
        DateMixin,
        check24WidgetMixin,
    ],
    props: {
        hostId: {
            type: Number,
        },
        sectionPadding: {
            type: String,
            default: '40px',
        },
        ...CategoryPageProps,
    },
    data() {
        const isCasual = this.$globalConstants.host.project_id === 8;
        const isExitOverlayEnabled =
            this.$globalConstants.host.exit_overlay &&
            this.$globalConstants.host.exit_overlay.use_overlay;
        const isBot = window['__traffic_source__'] === 'bot';

        const disablePagination =
            isBot && this.$globalConstants.host.remove_pagination_for_bot_users;

        return {
            doubleRankingClass: 'double-ranking-items',
            quizState: {},
            filteredPartners: [],
            categoryState: categoryStore.state,
            articleState: articleStore.state,
            maxTableLength: isCasual ? 12 : 10,
            isExitOverlayEnabled,
            disablePagination,
            lastUpdateDate: this.getBrowserData() ?? this.fallbackDate(),
        };
    },
    beforeMount() {
        PaginationObserver.init(this.observerCallback);
        this.quizState = quizStore.state;
        if (this.disablePagination) {
            try {
                this.getPaginatedRankingList();
            } catch (e) {
                console.warn(
                    'getPaginatedRankingList failed on disable_pagination:',
                    e
                );
            }
            this.categoryState.scrollCompleted = true;
            try {
                PaginationObserver.getInstance().disconnect();
            } catch (e) {
                /* noop */
            }
        }
    },
    beforeDestroy() {
        PaginationObserver.getInstance().disconnect();
    },
    updated() {
        if (window.track) {
            window.track.event('optimize.activate');
        } else {
            this?.$gtm?.trackEvent({
                event: 'optimize.activate',
            });
        }
    },
    mounted() {
        this.getArticles();
    },
    methods: {
        loadQuestionnaireFirst(isOnPageQuiz = false) {
            if (this.$globalConstants?.host?.load_quiz_first && !isOnPageQuiz) {
                return !this.quizState.showQuestionnaire;
            }
            return true;
        },
        hasFlexibleSpaceActiveComponents(spaceArea, dynamicComponents) {
            return (
                this.getActiveComponents(
                    'CategoryPage',
                    spaceArea,
                    dynamicComponents
                ).length > 0
            );
        },
        filterPartners(data) {
            // fetch paginated partners
            if (!this.categoryState.scrollCompleted) {
                this.getPaginatedRankingList();
                this.categoryState.scrollCompleted = true;
                setTimeout(() => {
                    this.filteredPartners = data;
                }, 1000);
            } else {
                this.filteredPartners = data;
            }
        },
        onPartnerObserve(target) {
            if (this.disablePagination) {
                if (!this.categoryState.scrollCompleted) {
                    try {
                        this.getPaginatedRankingList();
                    } catch (e) {
                        console.warn(
                            'getPaginatedRankingList failed on disable_pagination observe:',
                            e
                        );
                    }
                    this.categoryState.scrollCompleted = true;
                }
                try {
                    PaginationObserver.getInstance().disconnect();
                } catch (e) {
                    /* noop */
                }
                return;
            }

            //ignore double ranking partner elements
            if (target.classList.contains(this.doubleRankingClass)) {
                PaginationObserver.getInstance().unobserve(target);
                return;
            }
            PaginationObserver.getInstance().unobserve(target);

            //filter double ranking partner elements
            const partnersList = [...target.parentElement.children].filter(
                (item) => {
                    return !item.classList.contains(this.doubleRankingClass);
                }
            );

            const currentPosition = [...partnersList].indexOf(target) + 1;
            const isLastElement = currentPosition === partnersList.length;
            const loadedAllPartners =
                currentPosition >= this.maxTableLength ||
                currentPosition >= this.categoryState.partnersCount;

            // fetch all partners if exit overlay enabled
            if (this.isExitOverlayEnabled) {
                if (!this.categoryState.scrollCompleted) {
                    this.getPaginatedRankingList();
                    this.categoryState.scrollCompleted = true;
                    PaginationObserver.getInstance().disconnect();
                }
                return;
            }

            if (isLastElement && !loadedAllPartners) {
                this.getPaginatedRankingList();
            }

            if (
                !!this.$globalConstants.components['PartnerCardCarousel']
                    ?.maxPartners &&
                !!this.$globalConstants.host['use_carousel']
            ) {
                if (
                    currentPosition >=
                    this.$globalConstants.components['PartnerCardCarousel']
                        .maxPartners
                ) {
                    PaginationObserver.getInstance().disconnect();
                    this.categoryState.scrollCompleted = true;
                }
            }

            if (loadedAllPartners) {
                PaginationObserver.getInstance().disconnect();
                this.categoryState.scrollCompleted = true;
            }
        },
        observerCallback(entries) {
            entries.forEach(({ target, isIntersecting }) => {
                if (isIntersecting) {
                    this.onPartnerObserve(target);
                }
            });
        },
    },
    computed: {
        heroBannerCategory() {
            const seoTags = this.$globalConstants.host.category_seo_tags || {};
            const baseCategory = seoTags[this.getCategorySlug()] || {};
            const category = { ...baseCategory };
            const isInvalidCategory =
                !category ||
                typeof category !== 'object' ||
                Object.keys(category).length === 0;

            if (isInvalidCategory && this.categoryState.isLoaded) {
                return this.categoryState.category;
            }

            if (
                !Object.prototype.hasOwnProperty.call(
                    category,
                    'header_banner_beta'
                )
            )
                category['header_banner_beta'] = null;
            if (
                !Object.prototype.hasOwnProperty.call(category, 'header_banner')
            )
                category['header_banner'] = null;
            /*let category =
               this.$globalConstants.host.category_seo_tags[
                   this.getCategorySlug()
               ];*/
            // category['header_banner_beta'] = null;
            // category['header_banner'] = null;
            return category;
        },
        showGamePage() {
            return Boolean(this.categoryState.category['show_adsense_games']);
        },
        showGameList() {
            return Boolean(this.categoryState.category['adsense_games']);
        },
        showUserLocation() {
            return (
                Boolean(this.$globalConstants.host['location']) &&
                Boolean(this.$globalConstants.user['userCity'])
            );
        },
        isHeroBannerBeta() {
            return (
                this.categoryPageState.heroType ===
                    HERO_COMPONENTS.HeroBannerBeta && this.isDesktop()
            );
        },
        rankingTablePartners() {
            const carousel =
                !!this.$globalConstants.components['PartnerCardCarousel'] &&
                !!this.$globalConstants.host['use_carousel'];
            if (carousel) {
                return this.displayedPartners.slice(
                    0,
                    this.$globalConstants.components['PartnerCardCarousel']
                        .maxPartners
                );
            }
            return this.displayedPartners;
        },
        showFeaturedPartner() {
            return (
                this.categoryState.scrollCompleted &&
                this.$globalConstants.host['featured_partner']
            );
        },
        showSidebarBillboard() {
            return (
                this.$globalConstants.host['sidebar_billboard_mobile'] &&
                this.categoryState.isLoaded &&
                this.categoryState['sidebar_billboard_partner'] &&
                this.isMobileDevice()
            );
        },
        categoryPageState() {
            return this.$globalConstants.components.CategoryPage;
        },
        mainPadding() {
            return this.isMobile() ? '10px' : this.sectionPadding;
        },
        flexibleSpaceStyle() {
            return {
                padding: this.mainPadding,
                'max-width': this.maxWidth,
            };
        },
        mainStyle() {
            return {
                padding: this.mainPadding,
                paddingBottom: '0',
                'max-width': this.maxWidth,
                'flex-direction': this.isMobileDevice()
                    ? 'column'
                    : this.sidebarPosition === 'left'
                    ? 'row-reverse'
                    : 'row',
                'z-index': this.isHeroBannerBeta ? 5 : 3,
            };
        },
        flexibleSpaceAComponents() {
            return {
                [PARTNER_PODIUM]: {
                    shouldShow: this.$globalConstants.host.use_podium,
                },
                [CATEGORY_TAGS]: {
                    shouldShow: this.$globalConstants.host['show_categories'],
                },
                [HERO_SEARCH_BAR]: {
                    shouldShow: this.$globalConstants.host['search_bar'],
                },
                [HERO_BILLBOARD]: {
                    shouldShow:
                        this.$globalConstants.host['sidebar_billboard_desktop'],
                },
                [BLACK_FRIDAY_BADGE]: {
                    shouldShow:
                        Boolean(
                            this.$globalConstants.host['black_friday_badge']
                        ) ||
                        Boolean(this.$globalConstants.host['christmas_badge']),
                },
                [PODIUM_PRO]: {
                    shouldShow: this.$globalConstants.host.use_podium,
                },
            };
        },
        showFlexibleSpaceA() {
            return this.hasFlexibleSpaceActiveComponents(
                'A',
                this.flexibleSpaceAComponents
            );
        },
        showBottomSection() {
            const dynamicComponents = {
                [SUMMARY]: {
                    shouldShow: true,
                },
                [PARTNER_PODIUM]: {
                    shouldShow: this.$globalConstants.host.use_podium,
                },
                [PARTNER_CARD_CAROUSEL]: {
                    shouldShow: this.$globalConstants.host['use_carousel'],
                },
            };

            if (this.check24WidgetEnabled) {
                return this.hasFlexibleSpaceActiveComponents(
                    'C',
                    dynamicComponents
                );
            }
            return (
                this.hasFlexibleSpaceActiveComponents('C', dynamicComponents) &&
                this.categoryState.scrollCompleted
            );
        },
        showDisclosure() {
            return this.$globalConstants.host['disclosure'] === 1;
        },
        showBrandLogo() {
            return this.$globalConstants.host.compado_logo;
        },
        showSideColumn() {
            const dynamicComponents = {
                [TESTIMONIALS]: {
                    shouldShow: true,
                },
                [ARTICLE_CARDS]: {
                    shouldShow: true,
                },
                [PARTNER_PODIUM]: {
                    shouldShow: this.$globalConstants.host.use_podium,
                    props: {
                        ...this.$globalConstants.components[PARTNER_PODIUM],
                        partners: this.podiumPartners,
                    },
                },
                [SIDEBAR_BILLBOARD]: {
                    shouldShow:
                        this.$globalConstants.host[
                            'sidebar_billboard_desktop'
                        ] &&
                        !this.isMobileDevice() &&
                        this.categoryState.isLoaded &&
                        this.categoryState['sidebar_billboard_partner'],
                    props: {
                        partner:
                            this.categoryState['sidebar_billboard_partner'],
                    },
                },
            };
            const hasActiveComponents = this.hasFlexibleSpaceActiveComponents(
                'B',
                dynamicComponents
            );
            const showOnDesktop = this.isDesktop() && this.showSidebar;

            return (
                ((this.isMobileDevice() &&
                    this.categoryState.scrollCompleted) ||
                    showOnDesktop) &&
                hasActiveComponents
            );
        },
        showMainSectionBackground() {
            return (
                this.showRankingBackgroundImage &&
                !this.isMobileDevice() &&
                this.$globalConstants.host.main_section_background
            );
        },
        showArticles() {
            return (
                this.articleState.articles &&
                this.$globalConstants.host.project_id === 20
            );
        },
        heroBannerBetaSpaceBStyle() {
            if (!this.isHeroBannerBeta) return {};
            let marginTop = 0;

            const activeComponents = this.getActiveComponents(
                'CategoryPage',
                'A',
                this.flexibleSpaceAComponents
            );

            if (activeComponents.length === 1) {
                marginTop = '70px';
            }
            return {
                marginTop,
            };
        },
        heroBannerBetaSpaceAStyle() {
            if (!this.isHeroBannerBeta || this.isDesktopSmall()) return {};
            let marginTop = 0;
            let gap = 0;

            const activeComponents = this.getActiveComponents(
                'CategoryPage',
                'A',
                this.flexibleSpaceAComponents
            );
            if (activeComponents.length > 1) {
                marginTop = '-180px';
                gap = '5px';
            }

            if (activeComponents.length === 1) {
                marginTop = '-180px';

                try {
                    marginTop = this.$globalConstants.components[
                        'CategoryPage'
                    ]['spaceADesktop'].includes(PODIUM_PRO)
                        ? '-120px'
                        : marginTop;

                    marginTop = this.$globalConstants.components[
                        'CategoryPage'
                    ]['spaceADesktop'].includes(PARTNER_PODIUM)
                        ? '-120px'
                        : marginTop;
                } catch (e) {
                    console.log(e);
                }
            }
            return {
                gap,
                marginTop,
            };
        },
    },
    watch: {
        $route(to) {
            const isNavigatingToCategoryPage =
                to.name === 'home' || this.$route.name === 'category';
            if (isNavigatingToCategoryPage) {
                categoryStore.updateRankingList(null);
                this.getCategory();
            }
        },
        hostId(newHostId, oldHostId) {
            if (oldHostId !== newHostId && window['__storybook__']) {
                this.getCategory();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';

#check-24-iframe {
    width: 100%;
    min-height: 850px;
    border: none;

    @include mq('tablet') {
        min-height: 1024px;
    }

    @include mq('desktop') {
        min-height: 400px;
    }
}

.page-wrapper {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
    z-index: 1;

    .hero-section {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        z-index: 4;
        min-height: 80px;
    }

    .main-section {
        display: flex;
        width: 100%;
        flex-direction: column;
        max-width: 1200px;
        align-items: flex-start;
        z-index: 3;
        position: relative;

        @include mq('tablet') {
            gap: 40px;
        }

        .main-column {
            width: 100%;
            flex: 1 2 75%;
        }

        .side-column {
            flex: 0 1 25%;
            z-index: 1;
            width: 100%;
            min-width: 300px;
            @include mq('tablet') {
                width: auto;
                gap: 40px;
                min-height: 500px;
            }

            &.__sticky {
                position: sticky;
                top: 0;
                height: fit-content;
            }

            .article-card {
                margin-bottom: 20px;
            }
        }

        .ranking-background-image {
            position: absolute;
            width: 140%;
            object-fit: fill;
            z-index: 0;
            max-width: 1600px;
            left: 50%;
            top: 0;
            transform: translateX(-50%);
            height: 100%;
        }
    }

    .bottom-section {
        z-index: 3;
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .articles-summary {
        width: 100%;
        display: flex;
        flex-direction: column;
        max-width: $max-width;
        margin: 30px auto 0;
        box-sizing: border-box;
        padding: 0 10px;

        @include mq('tablet') {
            padding: 0;
            display: grid;
            grid-template-columns: 3fr 1fr;
            column-gap: 25px;
            grid-template-rows: 1fr;
        }

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            display: flex;
            flex-direction: row-reverse;
        }
    }

    .flexible-space-wrapper {
        display: flex;
        flex-direction: column;
        gap: 24px;
        max-width: 1200px;
    }

    .hero-tool-bar {
        height: 50px;
        background: #efefef;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 5px 10px 15px 10px;

        div {
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                padding-right: 5px;
            }

            span {
                font-size: 14px;
                align-items: center;
                color: #898989;
            }
        }

        .rating-disclosure {
            margin-top: 0;
        }
    }

    .hero-banner-overlay {
        margin-top: 0;

        @include mq('desktop') {
            margin-top: -140px;
        }
    }

    .hero-banner-overlay-partner {
        margin-top: -2px;
    }

    .podium-wrapper {
        width: inherit;
        padding: 20px 10px;
    }
}
</style>
